import { RESET_DETAILS, FETCHING_DETAILS, FETCH_DETAILS_SUCCESS, FETCH_DETAILS_FAIL } from '../actions/types'

const INITIAL_STATE = {
  loading: false,
  category: null,
  data: {},
  errorMsg: null
}

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case RESET_DETAILS:
      return { ...state, ...INITIAL_STATE }
    case FETCHING_DETAILS:
      return { ...state, loading: true }
    case FETCH_DETAILS_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        category: action.payload.category,
        loading: false
      }
    case FETCH_DETAILS_FAIL:
      return { ...state, ...INITIAL_STATE, errorMsg: action.payload }
    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/detailsReducer.js